import { AppShell, Box } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import { MobileHeader } from './MobileHeader';
import { BottomNav } from './BottomNav';
import { usePlatform } from '@/hooks/usePlatform';
import { InstallPrompt } from '@/components/pwa/InstallPrompt';
import { OfflineIndicator } from '@/components/pwa/OfflineIndicator';
import { ParentQuickActionsFAB } from '../parent/ParentQuickActionsFAB';

/**
 * Mobile Layout Component
 *
 * Main layout shell for mobile devices
 * Uses Mantine AppShell with:
 * - Fixed header (56px)
 * - Bottom navigation (56px + safe area)
 * - Scrollable content area
 * - iOS safe area support
 */
export function MobileLayout() {
  const { isIOS } = usePlatform();

  return (
    <>
      {/* PWA Components */}
      <InstallPrompt />
      <OfflineIndicator />

      <AppShell
        header={{ height: 56 }}
        padding={0}
        styles={{
          main: {
            // Account for bottom nav + iOS safe area
            paddingBottom: isIOS
              ? 'calc(56px + env(safe-area-inset-bottom))'
              : '56px',
            // Account for header
            paddingTop: '56px',
            backgroundColor: '#f8f9fa',
            minHeight: '100vh',
          },
        }}
      >
        {/* Top Header */}
        <AppShell.Header
          style={{
            borderBottom: '1px solid #e9ecef',
          }}
        >
          <MobileHeader />
        </AppShell.Header>

        {/* Main Content */}
        <AppShell.Main>
          <Box p="md">
            <Outlet />
          </Box>
        </AppShell.Main>

        {/* Bottom Navigation */}
        <BottomNav />
      </AppShell>

      {/* Parent Quick Actions FAB */}
      <ParentQuickActionsFAB />
    </>
  );
}
